import { isNative, useListCategoryCarouselQuery } from "@stepapp/core";
import { Block, Carousel, Image, LinePlaceholder, spacing, useBreakpoints } from "@stepapp/ui";
import { useLocalSearchParams } from "expo-router";
import React from "react";
import { StyleSheet, useWindowDimensions } from "react-native";

type CategoryBannerProps = {
  categoryDesktopImg?: string;
  categoryMobileImg?: string;
};

const CategoryBanner = ({ categoryDesktopImg, categoryMobileImg }: CategoryBannerProps) => {
  const { mobileOnly, sm } = useBreakpoints();
  const { width: screenWidth } = useWindowDimensions();
  const { id } = useLocalSearchParams<{ id: string }>();

  const { data: listCategoryCarousel, loading: listCategoryCarouselLoading } =
    useListCategoryCarouselQuery({
      variables: { categoryId: id },
      fetchPolicy: "cache-first",
    });

  const carouselItems = listCategoryCarousel?.listCategoryCarousel;

  const singleImage = mobileOnly ? categoryMobileImg : categoryDesktopImg;

  const showSingleImage = !carouselItems?.length && !listCategoryCarouselLoading && singleImage;

  const screenContainerWidth = screenWidth > 772 ? 772 : screenWidth;
  const imgWidth = screenContainerWidth - (isNative ? 0 : 40);
  const imgHeight = sm ? 32.5 : 26.5;

  return (
    <Block marginTop={isNative ? 0 : 3.75} marginBottom={mobileOnly ? 3 : 5}>
      {listCategoryCarouselLoading && !carouselItems?.length && (
        <LinePlaceholder
          borderRadius={isNative ? 0 : 1.25}
          height={imgHeight}
          width={imgWidth / 8}
        />
      )}

      {!!carouselItems?.length && (
        <Carousel data={carouselItems || []} width={imgWidth} height={spacing.unit * imgHeight} />
      )}

      {showSingleImage && (
        <Image
          source={singleImage}
          contentFit="cover"
          height={spacing.unit * imgHeight}
          width={imgWidth}
          style={styles.image}
        />
      )}
    </Block>
  );
};

export default React.memo(CategoryBanner);

const styles = StyleSheet.create({
  image: {
    borderRadius: spacing.radius,
  },
});
